import React from "react";
import MainLayout from "../../../components/Layouts";
import UnsettledOrderList from "../../../components/settlement/unsettledOrder";

const unsettledOrderPage = () => {
  return (
    <MainLayout>
      <UnsettledOrderList />
    </MainLayout>
  );
};

export default unsettledOrderPage;
